import { Sun, Moon, Sparkles } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";

const ThemeToggle = () => {
  const {
    theme,
    toggleTheme,
    // You can still destructure these if you need them for something else:
    isDonnieModeUnlocked,
    isMojoModeUnlocked,
    isJusticeModeUnlocked,
    isOwenModeUnlocked,
    isHanukkahModeUnlocked,
  } = useTheme();

  const getThemeIcon = () => {
    switch (theme) {
      case "dark":
        return <Moon size={20} />;

      // Group all "special" themes under Sparkles
      case "donnie":
      case "mojo":
      case "justice":
      case "owen":
      case "hanukkah":
        return <Sparkles size={20} />;

      // Default to Sun icon (covers "light" or anything not specified)
      default:
        return <Sun size={20} />;
    }
  };

  const getThemeText = () => {
    switch (theme) {
      case "light":
        return "Light Mode";
      case "dark":
        return "Dark Mode";
      case "donnie":
        return "Donnie Mode";
      case "mojo":
        return "Mojo Mode";
      case "justice":
        return "Justice Mode";
      case "owen":
        return "Owen Mode";
      case "hanukkah":
        return "Hanukkah Mode";
      default:
        // Fallback if something unexpected
        return "Light Mode";
    }
  };

  return (
    <button onClick={toggleTheme} className="theme-toggle">
      {getThemeIcon()}
      <span>{getThemeText()}</span>
    </button>
  );
};

export default ThemeToggle;
